// project.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { Project } from '../../models/project-field';
import { ProjectActions } from '../actions/project.actions';
import { initialState } from '../states/project.state';

export const projectReducer = createReducer(
  initialState,
  on(ProjectActions.loadProject, (state) => ({ ...state, loading: true })),
  on(ProjectActions.loadProjectSuccess, (state, { projectList }) => ({
    ...state,
    loading: false,
    projectList,
  })),
  on(ProjectActions.createProjectSuccess, (state, { project }) => ({
    ...state,
    projectList: [project, ...state.projectList]
  })),
  on(ProjectActions.editProjectSuccess, (state, { project }) => ({
    ...state,
    projectList: state.projectList.map((org: Project) =>
      org.id === project?.data?.id ? project?.data : org
    )
  })),
  on(ProjectActions.deleteProjectSuccess, (state, { projectId }) => ({
    ...state,
    projectList: state.projectList.filter((org) => org.id !== projectId)
  })),
  on(ProjectActions.loadProjectFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
